import AbcQrcode from "./index.vue";
export default AbcQrcode;

